import { UntitledUI } from "../untitled-ui"

export type ColorStyle = typeof UntitledUI.colorStyles.primary
export const ColorStyles = UntitledUI.colorStyles
export const OverlayShadow = "2px 2px 10px #bbb"
export type ColorWeight = keyof ColorStyle
export type ColorName = keyof typeof ColorStyles
